//CSS
import "../../Components/Page/Page.css";
import engine from "../../Images/OurStory/Wankel.png";

import tradeShow from "../../Images/TradeShow/TradeShowGeneral.jpg";
import POC1 from "../../Images/TradeShow/POC1-v103.jpg";
import Flat6 from "../../Images/TradeShow/Flat6.png";
import ESPECSC from "../../Images/TradeShow/ESPEC_SC.png";

//React
import React from "react";
import SecHeader from "../../Components/SecHeader/SecHeader";
import SubSection from "../../Components/Section/SubSection";
import ImageComp from "../../Components/ImageContainer/ImageComp";
import PipeDriveEmbed from "../../Pages/PipeDrive/PipeDriveEmbed";
import { Link } from "react-router-dom";

const TorontoContent: React.FC = () => {
    return (
        <div id="Goals" className="sectionContainer">
            <SecHeader title="Our Show" />
            {/* <SubSection>
                <div className="description-container">
                    <p>
                        <ul>
                            <li> Come to our booth and talk to us</li>
                            <li> See our engine in person</li>
                            <li> Try our ESPEC Demo</li>
                            <li> Get more even more information by using our easy sign MNDA to see the big picture</li>
                        </ul>
                    </p>{" "}

                </div>
            </SubSection>             */}
            <SubSection>
                <ImageComp imageSource={tradeShow} width={"25vw"} />
                <div className="description-container">
                    <p>
                        Come Visit Our Booth 2267 in hall 2, with Pro-Pak APU Systems at the Truck World Trade Show in Toronto. We will be showcasing our various
                        bench test engine and proof of concept assemblies, CAD Drawings, ESPEC™ Demo, and much more. Find one of our available
                        team members to dive deeper into ELF-Tech. Discover where we are headed, and find out how you can be a part of
                        our journey.
                    </p>{" "}
                </div>
            </SubSection>            
            <SecHeader title="View Our Engine Variations" />
            {/* <SubSection isSplit={false}>
                <div className="description-container">
                    <p>
                        Come take a look at any one of our engine assemblies as proof of our inovative concepts, the speed
                        of our development, and what the future of engine design will look like.
                    </p>{" "}
                </div>
            </SubSection> */}
             <SubSection>                
                <ImageComp imageSource={Flat6} width={"25vw"} />
                <div className="description-container">
                    <h2>3D Printed Boxer-6</h2>
                    <p>
                        Using 3D printed parts with a cross section cut out, this shows a variation of our early boxer-6 designs, 
                        with innovative valve placement and mechanical timing.

                        {/* This is the second model created using 3D printed parts with a cross section cut out. This model shows a veriation of 
                        our early Boxer-6 designs complete with inovative valve placement and mechanical timing. */}
                    </p>{" "}
                </div>
            </SubSection>
            <SubSection>
                
                <div className="description-container">
                    <h2>Proof of Concept Assembly</h2>
                    <p>
                        {/* It demonstrates our self balancing, compact internals version 001 with stabilized pistons. internals version 1. Made from off 
                        the shelf 
                        parts. */}

                        Made from off the self parts, this proof of concept assembly version 001 demonstrates our self balancing and compact 
                        internals with stabilized pistons.

                        {/* This is our very first model created from off the shelf parts in a home garage by the creator of the
                        inovative design. This displays the basic layout of one of the many revolutionary engines, how even simplified assembaly
                        can be achieved, and how baic motion of the engine works. */}
                    </p>{" "}
                </div>
                <ImageComp imageSource={POC1} width={"25vw"} />
            </SubSection>           
            <SubSection>
                <ImageComp imageSource={POC1} width={"25vw"} />
                <div className="description-container">
                    <h2>Proof of Concept Assembly Test v002</h2>
                    <p>
                        
                        Built from ELF-Tech CADs showing internals version 2 with one-piece cranks, three 
                        connecting rods, and three pistons.

                    </p>{" "}
                </div>
            </SubSection>
            <SubSection>
                <div className="description-container">
                    <h2>Badger Test Engine Full Assembly</h2>
                    <p>
                        Built from ELF-Tech CADs showing internals version 3 with multi-part cranks, three 
                        connecting rods, and three pistons.

                        
                    </p>{" "}
                </div>
                <ImageComp imageSource={Flat6} width={"25vw"} />
            </SubSection>

            
            <SecHeader title="ESPEC Comparison Tool" />
            <SubSection>
                <ImageComp imageSource={ESPECSC} width={"25vw"} />
                <div className="description-container">
                    <p>
                        For the very first time users are able to view and interact with a limited version of our extensive {" "}
                        <Link to="../user-login">ESPEC Calculator</Link>.  
                        Sort for the desired engine that will fit your needs.
                        Try to compare statistics across several different engine models, and see how our ELF-Tech™ designs compare.
                    </p>{" "}
                </div>
            </SubSection>


            <SecHeader title="Contact Us" />
            <SubSection isSplit={false}>
                <div className="description-container">
                    <p>
                        We would like to hear more from you please reach out through our Pipedrive link to help us learn more about you, and
                        your interest in What we can offer you. If you have not already dones so please create a {" "}
                        <Link to="../user-login">user profile</Link> so we can further 
                        assist you in your inquaries.
                    </p>{" "}
                </div>
            </SubSection>
            <PipeDriveEmbed index={0} />
            <SecHeader title="Location" />
            <SubSection isSplit={false}>
                <div className="description-container">
                    <p>
                        Our exhibit is in hall 2 booth 2267 with Pro-Pak APU Systems.

                    </p>{" "}

                </div>
            </SubSection>
            <SecHeader title="More Information" />
            <SubSection isSplit={false}>
                <div className="description-container">
                    <p>
                    Here is some additional information and links about us and the trade show. Please feel free to reach out to us with any questions you may have, and we hope to see you at the event!
                    <ul>
                        <li><Link to="https://www.truckworld.ca/">Truck World</Link></li>
                        <li><Link to="/register">Register</Link></li>
                        <li><Link to="/espec">ESPEC Calculator</Link></li>
                        <li><Link to="/ourStory">About Us</Link></li>
                        <li><Link to="/pipedrive">Contact Information</Link></li>
                    </ul>
                    </p>{" "}

                </div>
            </SubSection>


        </div>
    );
};

export default TorontoContent;
